// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3kgjp","errorLogs":"styles_errorLogs__1w7qo"};